// SELETOR_PAINEL_0211: envia X-Painel nas telas com seletor (Dashboard, Financeiro, Vendas, Clientes).
import axios from 'axios';
export const SEL_KEY_0211 = 'painel_sel_0211';
export const SEL_PATHS_0211 = ['/dashboard', '/financeiro', '/sales', '/gestor-xui/clients', '/gestor-xui/vencimentos', '/gestor-xui/tests']; // EQUIPE_V2_0311: + Vencimentos/Testes
export function telaComSeletor0211(p) {
  const x = p || (typeof window !== 'undefined' ? window.location.pathname : '');
  if (x.startsWith('/gestor-xui/vencimentos')) return false; /* VENC_EQUIPE_0411b: Vencimentos tem seletor proprio (Layout renderiza antes do chunk lazy) */ // VENC_EQUIPE_0411
  return SEL_PATHS_0211.some((s) => x === s || x.startsWith(s + '/'));
}
export function painelSelecionado0211() {
  try { return localStorage.getItem(SEL_KEY_0211) || ''; } catch (e) { return ''; }
}
export function setPainel0211(id) {
  try { if (id) localStorage.setItem(SEL_KEY_0211, id); else localStorage.removeItem(SEL_KEY_0211); } catch (e) {}
}
let instalado = false;
export function instalarSeletor0211() {
  if (instalado) return; instalado = true;
  axios.interceptors.request.use((cfg) => {
    const p = painelSelecionado0211();
    const m = String(cfg.method || 'get').toLowerCase();
    if (p && m === 'get' && telaComSeletor0211() && !(cfg.headers && cfg.headers['X-Painel-Proprio-0411'])) { // VENC_EQUIPE_0411: tela com seletor proprio
      cfg.headers = cfg.headers || {};
      cfg.headers['X-Painel'] = p;
    }
    return cfg;
  });
  axios.interceptors.response.use((r) => r, (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && d === 'Painel fora da sua equipe.' && painelSelecionado0211()) {
      setPainel0211('');
      try { window.location.reload(); } catch (e) {}
    }
    return Promise.reject(err);
  });
}
instalarSeletor0211();
